// extracted by mini-css-extract-plugin
module.exports = {"primaryButton":"ClearShelfButton-primaryButton-1-bWD9","clearShelfContainer":"ClearShelfButton-clearShelfContainer-1UqeHs","clearIcon":"ClearShelfButton-clearIcon-3bOFXb"};